"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAiConfigJsonSchema = toAiConfigJsonSchema;
const zod_1 = require("zod");
function toAiConfigJsonSchema(zodSchema) {
    return zod_1.z.toJSONSchema(zodSchema);
}
